import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login'
import Home from '../views/Home.vue'
import PianificazioneAttività from '../views/pianificazioneAttivita.vue'
import GoogleMaps from '../views/googleMaps.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/pianificazioneAttivita',
    name: 'Pianificazione Attività',
    component: PianificazioneAttività
  },
  {
    path: '/googleMaps',
    name:'Google Maps',
    component: GoogleMaps
  }
]

const router = new VueRouter({
  routes
})

export default router
